<video #target class="video-js" (error)="onError($event)" controls playsinline preload="auto"></video>
